<template>
    <div class="footer">
        关于我们|联系我们|联系客服|友情链接
        <br/> 京公网安备 11000002000088号|京ICP证070359号
        <br/> 互联网出版许可证编号新出网证(京)字150号|出版物经营许可证|网络文化经营许可证京网文[2014]2148-348号|违法和不良信息举报电话：4006561155
        <br/> Copyright © 2004 - {{date}} {{siteInfo.SystemName}} {{siteInfo.SystemDomain}} 版权所有|消费者维权热线：4006067733经营证照
        <br/> 经营性网站备案中心可信网站信用评估网络警察提醒你诚信网站中国互联网举报中心网络举报APP下载
        <br/>
        <div v-if="config.isProxy" style="position:fixed;right:1%;top:20%;line-height:30px;z-index:2">
            线上模式:
            <el-switch v-model="config.isOnline" active-text="线上模式" inactive-text="线上模式"> </el-switch>
            <br/>代理模式:
            <el-switch v-model="config.isProxy" active-text="代理模式" inactive-text="代理模式"> </el-switch>
        </div>
    </div>
</template>
<script type="text/javascript">
    import config from '@/apis/config.js'
    import {
        mapGetters
    } from 'vuex'
    export default {
        data() {
            return {
                date: new Date().getFullYear(),
                config: config,
            }
        },
        mounted(){
            window.config=this.config;
        },
        computed: {
            ...mapGetters(['siteInfo'])
        }
    };

</script>



// WEBPACK FOOTER //
// footer.vue?b891ab5a